export enum RequestHistoryStatus {
  Failed = 'FAILED',
  Pass = 'PASS'
}
